import React from "react";
import {
  Container,
  Title,
  Text,
  Card,
  Stack,
  Center,
  Grid,
  ThemeIcon,
  Box
} from '@mantine/core';
import {
  IconClipboardList,
  IconPhoneCall,
  IconHistory,
  IconShieldCheck,
  IconSitemap,
  IconFileSpreadsheet,
  IconTools
} from '@tabler/icons-react';

const TOOL_ICONS = {
  plans: IconClipboardList,
  run: IconPhoneCall,
  history: IconHistory,
  allowlist: IconShieldCheck,
  diagrams: IconSitemap,
  excel: IconFileSpreadsheet
};

function LandingPage({ tools, onSelect }) {
  return (
    <Box
      style={{
        minHeight: '80vh',
        background: 'linear-gradient(135deg, #5f3dc4 0%, #e5dbff 100%)',
        padding: '40px 20px',
        borderRadius: '16px'
      }}
    >
      <Container size="lg">
        <Center>
          <Stack align="center" gap="xl" style={{ maxWidth: '1000px' }}>
            <Stack align="center" gap="md">
              <Title
                order={1}
                size="2.5rem"
                fw={700}
                style={{ color: 'white', textAlign: 'center' }}
              >
                Service IVR Testing (SIT)
              </Title>
              <Text
                size="xl"
                style={{ color: 'rgba(255, 255, 255, 0.92)', textAlign: 'center', maxWidth: '720px' }}
              >
                Automated outbound test calls into your CCaaS IVRs. Drive DTMF, speech,
                and AI-agent flows against a structured test plan, then evaluate every
                step with an LLM and correlate to CCaaS-side call logs.
              </Text>
            </Stack>

            <Grid gutter="xl" style={{ width: '100%', maxWidth: '1200px' }}>
              {Object.entries(tools).map(([key, tool]) => {
                const IconComponent = TOOL_ICONS[key] || IconTools;

                return (
                  <Grid.Col key={key} span={{ base: 12, sm: 6, md: 4 }}>
                    <Card
                      shadow="xl"
                      padding="xl"
                      radius="md"
                      onClick={() => onSelect(key)}
                      style={{
                        background: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        height: '300px',
                        display: 'flex',
                        flexDirection: 'column',
                        border: '2px solid transparent'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-6px)';
                        e.currentTarget.style.boxShadow = '0 18px 36px rgba(0, 0, 0, 0.18)';
                        e.currentTarget.style.border = '2px solid var(--mantine-color-violet-6)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.10)';
                        e.currentTarget.style.border = '2px solid transparent';
                      }}
                    >
                      <Stack align="center" gap="md" style={{ flex: 1, justifyContent: 'space-between', padding: '10px 0' }}>
                        <Stack align="center" gap="md">
                          <ThemeIcon size={64} radius="md" color="violet" variant="light">
                            <IconComponent size={36} />
                          </ThemeIcon>
                          <Title order={3} size="1.2rem" fw={600} align="center">
                            {tool.name}
                          </Title>
                        </Stack>

                        <Text
                          size="sm"
                          color="dimmed"
                          align="center"
                          style={{ lineHeight: 1.4, padding: '0 6px' }}
                        >
                          {tool.description}
                        </Text>

                        <Text
                          size="xs"
                          color="violet"
                          align="center"
                          fw={600}
                          style={{
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            opacity: 0.85
                          }}
                        >
                          Click to open
                        </Text>
                      </Stack>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          </Stack>
        </Center>
      </Container>
    </Box>
  );
}

export default LandingPage;
